import { I18n } from '@calendly/i18n'
import { Popup } from '@calendly/ui/components/popup'
import { useDispatch, useSelector } from 'react-redux'

import { AddToGroupForm } from 'features/add_users_to_group'

import { isAddToGroupPopupOpenSelector, selectedIdsSelector } from './selectors'
import { clearSelection, closeAddToGroupPopup, fetchMemberships } from './slice'

export const AddToGroupPopup = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(isAddToGroupPopupOpenSelector)
  const selectedIds = useSelector(selectedIdsSelector)

  const onClose = () => dispatch(closeAddToGroupPopup())
  const onSuccess = () => {
    dispatch(fetchMemberships())
    dispatch(clearSelection())
  }

  return (
    <Popup
      isOpen={isOpen}
      title={I18n.t('publisher.organization.members.add_to_group.title')}
      onClose={onClose}
    >
      <AddToGroupForm
        onClose={onClose}
        onSuccess={onSuccess}
        organizationMembershipIds={selectedIds}
        subtitle={I18n.t('publisher.organization.members.add_to_group.selected', { count: selectedIds.length })}
      />
    </Popup>
  )
}
